import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_ALL_SETTINGS,
  EDIT_SETTINGS,
  EDIT_TAXNUMBER,
  SUBMIT_IDENTITY,
  GET_IDENTITY,
  GET_TAXNUMBER,
} from "./actionTypes";

import {
  getAllSettingsApi,
  editSettingsApi,
  editTaxNumberApi,
  getIdentityVerificationApi,
  submitIdentityVerificationApi,
  getTaxNumberApi,
} from "api/settings";

import {
  getAllSettingsSuccess,
  getAllSettingsFailure,
  editSettingsSuccess,
  editSettingsFailure,
  submitIdentityVerificationFailure,
  submitIdentityVerificationSuccess,
  editTaxNumberFailure,
  editTaxNumberSuccess,
  getIdentityVerificationSuccess,
  getIdentityVerificationFailure,
  getTaxNumberSuccess,
  getTaxNumberFailure,
} from "./actions";

// api calls
function* getAllSettingss() {
  try {
    const { data } = yield call(getAllSettingsApi);

    yield put(getAllSettingsSuccess(data));
  } catch (error) {
    yield put(getAllSettingsFailure(error.response?.data?.message || error));
  }
}

function* editSettings({ payload }) {
  try {
    const { data } = yield call(editSettingsApi, payload);

    yield put(editSettingsSuccess(data));
  } catch (error) {
    yield put(editSettingsFailure(error.response?.data?.message || error));
  }
}

function* getTaxNumber() {
  try {
    const { data } = yield call(getTaxNumberApi);

    yield put(getTaxNumberSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getTaxNumberFailure(error.response?.data || error));
  }
}

function* editTaxNumber({ payload }) {
  try {
    const { data } = yield call(editTaxNumberApi, {
      data: payload.data,
    });

    yield put(editTaxNumberSuccess(data));
    payload?.navigate(-1);
  } catch (error) {
    yield put(editTaxNumberFailure(error.response?.data || error));
  }
}

function* getIdentityVerification() {
  try {
    const { data } = yield call(getIdentityVerificationApi);

    yield put(getIdentityVerificationSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getIdentityVerificationFailure(error.response?.data || error));
  }
}

function* identityVerification({ payload }) {
  try {
    const { data } = yield call(submitIdentityVerificationApi, payload);

    yield put(submitIdentityVerificationSuccess(data));
    payload?.navigate(-1);
  } catch (error) {
    yield put(submitIdentityVerificationFailure(error.response?.data || error));
  }
}

// watchers
export function* watchgetAllSettings() {
  yield takeEvery(GET_ALL_SETTINGS, getAllSettingss);
}

export function* watcheditSettings() {
  yield takeEvery(EDIT_SETTINGS, editSettings);
}

export function* watchGetTaxNumber() {
  yield takeEvery(GET_TAXNUMBER, getTaxNumber);
}

export function* watchEditTaxNumber() {
  yield takeEvery(EDIT_TAXNUMBER, editTaxNumber);
}

export function* watchGetIdentityVerification() {
  yield takeEvery(GET_IDENTITY, getIdentityVerification);
}

export function* watchSubmitIdentityVerification() {
  yield takeEvery(SUBMIT_IDENTITY, identityVerification);
}

function* settingsSaga() {
  yield all([
    fork(watchgetAllSettings),
    fork(watcheditSettings),
    fork(watchGetTaxNumber),
    fork(watchEditTaxNumber),
    fork(watchGetIdentityVerification),
    fork(watchSubmitIdentityVerification),
  ]);
}

export default settingsSaga;
